import { useSubmit, UseSubmitProps } from 'hooks/use-submit'
// import { parseCookieString } from 'shared-code/util'
import { PostContext } from 'shared-components/contexts/PostContext'
import { DSSubmitSubscribe } from 'shared-definitions/types'
import { useFormAppEvents } from 'shared-components/hooks/use-form-app-events'

export function useNewsletterSubscribe(): UseSubmitProps<Omit<DSSubmitSubscribe, 'vars'>> {
  const postMeta = PostContext.useContainer()
  const { formSuccessEvent, formFailureEvent, formStartedEvent } = useFormAppEvents()

  const source = (postMeta.subscribeTags.length ? postMeta.subscribeTags[0] : 'Features')
    .replace(/[\s-_]+/g, '_')
    .toUpperCase()

  return useSubmit(async ({ dataSource, params }) => {
    if (params.choices.length === 0) {
      return false
    }

    const formEventPayload = {
      name: 'newsletters-signup',
      id: null,
      heading: 'The only tech newsletter you need.',
      label: 'Subscribe',
      email: params.email,
    } as const

    formStartedEvent(formEventPayload)

    const result = await dataSource.sendSubscribe({
      ...params,
      vars: {
        global_account: 1,
        source: source === 'NEWSLETTERS' ? 'aa_newsletterpage' : `aa_article_${source}`,
      },
    })

    if (result.code === 200) {
      formSuccessEvent(formEventPayload)
    } else {
      formFailureEvent(formEventPayload)
    }

    return result.code === 200
  })
}
